export default __webpack_public_path__ + "static/media/02.c2a177be.png";